// Incoming properties:
// text                         => text will be shown on the tooltip
// activationDelay              => delay till tooltip will be shown

import React, { useState } from 'react';

interface ITooltip {
    children: any;
    text: string;
    activationDelay?: number;
    customStyle?: any;
    customTipStyle?: any;
}

const Tooltip = ({ children, text, activationDelay, customStyle, customTipStyle }: ITooltip) => {
    let activationTimeout: any;
    const [ isActive, setIsActive ] = useState<boolean>(false);

    const showTip = () => {
        activationTimeout = setTimeout(() => {
            setIsActive(true);
        }, activationDelay ?? 400);
    }

    const hideTip = () => {
        clearInterval(activationTimeout);
        setIsActive(false);
    }

    return (
        <div
            className="custom-tooltip"
            onMouseEnter={showTip}
            onMouseLeave={hideTip}
            style={customStyle ? customStyle : {}}
        >
            {children}
            {isActive &&
                <span
                    className="custom-tooltip__tip"
                    style={customTipStyle ? customTipStyle : {}}
                >
                    {text}
                </span>
            }
        </div>
    );
};

export default React.memo(Tooltip);
